

// import Footer from "../../components/footer/Footer";
import Footer from "../../components/dashboard/footer";

import Header from "../../components/dashboard/header";
import SideMenu from "../student/SideMenu";
import CPCBlock from "../quiz/InnerCPCBlock";
import earthImage from "../../assets/images/earth-quiz.svg";

const QuizHome = () => {


    return (

        <div id="layout-wrapper" className="student-cpc-user-pag">
            <Header />
            <SideMenu />
            <div className="quiz-page main-content user-management clients company quiz-section-page">
                <div className="page-content cpc-table student-cpc" id="cpc-table">

                    {earthImage && <CPCBlock img={earthImage} table={true} />}

                    <div className="row container-fluid col-lg-12 d-none" id="cpcTable">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h4 className="card-title">Previous Result</h4>
                                        {/* <button className="reset-quiz-btn ps-3 pe-3">View All</button> */}
                                    </div>
                                    <div className="quiz-table-wrapper">
                                        {/* <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="align-middle scno-col">SC.NO</th>
                                                    <th className="align-middle name-col">Quiz Name</th>
                                                    <th className="align-middle date-col">Date</th>
                                                    <th className="align-middle marks-col">Marks</th>
                                                    <th className="align-middle status-col">Status</th>
                                                    <th className="align-middle rank-col">Rank</th>
                                                    <th className="align-middle report-col">Reports</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">1</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">07 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-soft-success">Active</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">2</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">07 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-pill badge-soft-danger">Inactive</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">3</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">06 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-pill badge-soft-success">Active</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">4</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">05 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-pill badge-soft-success">Active</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">5</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">04 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-pill badge-soft-danger">Inactive</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="scno-col"><a href="javascript:void(0);" className="text-body">6</a></td>
                                                    <td className="name-col">Dermopathy Quiz</td>
                                                    <td className="date-col">04 Oct, 2019</td>
                                                    <td className="marks-col">250/300</td>
                                                    <td className="status-col"><span className="badge badge-pill badge-soft-success">Active</span></td>
                                                    <td className="rank-col">#6</td>
                                                    <td className="report-col"><a className="cpc-table-btn" href="">View Report</a></td>
                                                </tr>
                                            </tbody>
                                        </table> */}
                                        No Results found
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
            <Footer />
        </div>

    );
};

export default QuizHome;
